export default __webpack_public_path__ + "static/media/element_83.61e93775.avif";